import React from "react";
import { useToast } from "@chakra-ui/toast";
import Toast from "../components/Toast";

const useToasts = () => {
	const toast = useToast();

	return (title, description, duration, theme) => {
		toast({
			duration: duration,
			isClosable: true,
			position: "top",
			render: () => (
				<Toast
					title={title}
					description={description}
					theme={theme}
				/>
			)
		});
	};
};

export default useToasts;
